import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";

export function HomeScreen({ onStart }: { onStart(): void }) {
  return (
    <EditorialShell className="home-page" hideFooter>
      <section className="home-hero page-enter">
        <div className="home-copy-block">
          <div className="home-title-block">
            <h1 className="wordmark">WMLSTI</h1>
            <p className="product-name">WMLS 人格测试</p>
            <p className="product-note">五月天人生观测试</p>
          </div>
          <div className="home-statement">
            <p>九张专辑，各选一首。</p>
            <p>选你最喜欢的，或最像你的。</p>
            <p>九首选择，拼出你看世界的方式。</p>
          </div>
          <p className="dimension-line">相信 · 眷恋 · 倔强 · 远方 · 孤独 · 狂欢</p>
          <div className="home-action">
            <Action onClick={onStart}>开始测试</Action>
          </div>
        </div>
        <figure className="home-vinyl-stage">
          <div className="autobiography-player" role="img" aria-label="五月天《自传》黑胶唱片">
            <div className="vinyl-sleeve-edge" aria-hidden="true" />
            <div className="autobiography-vinyl">
              <span className="vinyl-label"><img src="/albums/09.jpg" alt="" /></span>
            </div>
            <div className="vinyl-tonearm" aria-hidden="true">
              <span className="tonearm-base" />
              <span className="tonearm-arm"><i /></span>
            </div>
          </div>
        </figure>
      </section>
    </EditorialShell>
  );
}
